import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4dc9a72d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cm-align-center",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_2 = { style: {"width":"100%","height":"auto","padding-bottom":"15px","display":"flex","flex-direction":"column"} }
const _hoisted_3 = { class: "cm-align-center" }
const _hoisted_4 = {
  class: "cm-ui-ml5",
  style: {"position":"relative","top":"10px","align-self":"flex-start"}
}
const _hoisted_5 = {
  class: "cm-align-center",
  style: {"line-height":"normal"}
}
const _hoisted_6 = { style: {"color":"var(--cm-color-text-secondary)"} }

import CmForm from '@/components/cmForm/index.vue'
import FormItem from '@/components/cmForm/FormItem.vue'
import { FormOpt, FormSize, FormType } from '@/components/cmForm/types'
import { formLabelStyle } from '@/components/cmForm/globalOpt'
import { errCodeToMsg } from '@/components/cmForm/err-code'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  ActionState,
  ActionType,
  ActionTypes,
  ApplyState,
  BtnActionType,
  PermissionsState
} from '@/views/dashboard/cascade-center/approval/types'
import { CascadeAppliesData } from '@/views/dashboard/cascade-center/approval/service'
import { Apply, AuthSubmitParams, CascadeService } from '@/views/dashboard/cascade-center/cascade-manage/service'
import { authMode } from '@/views/dashboard/cascade-center/cascade-manage/types'
import { RoleService } from '@/views/dashboard/_components/roleManage/service'
import { Role_Key } from '@/views/dashboard/_components/roleManage/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'cascade-superior-link-dialog',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "success"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()

const props = __props

const emit = __emit

const injector = useReflectiveInjector([CascadeService, RoleService])
const cascadeService = injector.get(CascadeService)
const roleService = injector.get(RoleService)

const getCascadeApplyApi = cascadeService.getCascadeApply.bind(cascadeService)
const getCascadeSuperiorApplyApi = cascadeService.getCascadeSuperiorApply.bind(cascadeService)
const getCascadeUnbindApi = cascadeService.getCascadeUnbind.bind(cascadeService)
const getCascadeRevokeApplyApi = cascadeService.getCascadeRevokeApply.bind(cascadeService)
const roleListApi = roleService.getRoleList.bind(roleService)

const ipv4WithHttpRegex =
  /^(https?:\/\/)(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/

function validateUrls (rule: unknown, value: string, callback: (e?: Error) => void) {
  if (!ipv4WithHttpRegex.test(value)) {
    callback(new Error(t('cascadeSuperiorLinkDialog.ipInvalid')))
    return
  }
  callback()
}

const applyStateLocaleKey: Record<ApplyState, 'preview' | 'allowed' | 'rejected' | 'disconnect'> = {
  [ApplyState.Preview]: 'preview',
  [ApplyState.Allowed]: 'allowed',
  [ApplyState.Rejected]: 'rejected',
  [ApplyState.Disconnect]: 'disconnect'
}

const formColumns = computed(() => ({
  server_host: {
    label: t('cascadeSuperiorLinkDialog.superiorIp'),
    rules: [{ custom: { validator: validateUrls } }],
    placeholder: t('cascadeSuperiorLinkDialog.superiorIpExample'),
    colOpt: { span: 16 },
    modelModifiers: { trim: true }
  },
  server_port: {
    label: t('cascadeSuperiorLinkDialog.superiorPort'),
    colOpt: { span: 8 },
    formItemOpt: { class: 'cm-ui-ml10' },
    placeholder: t('cascadeSuperiorLinkDialog.superiorPortExample'),
    modelModifiers: { trim: true, number: true }
  },
  access_code: {
    label: t('cascadeSuperiorLinkDialog.superiorAccessCode'),
    placeholder: t('cascadeSuperiorLinkDialog.superiorAccessCodePh'),
    hidden: () => form.value?.status && [ApplyState.Allowed].includes(form.value?.status as ApplyState),
    colOpt: { span: 24 },
    modelModifiers: { trim: true }
  },
  child_server_host: {
    label: t('cascadeSuperiorLinkDialog.localIp'),
    colOpt: { span: 16 },
    rules: [{ custom: { validator: validateUrls } }],
    placeholder: t('cascadeSuperiorLinkDialog.superiorIpExample'),
    modelModifiers: { trim: true }
  },
  child_server_port: {
    label: t('cascadeSuperiorLinkDialog.localPort'),
    colOpt: { span: 8 },
    formItemOpt: { class: 'cm-ui-ml10' },
    placeholder: t('cascadeSuperiorLinkDialog.superiorPortExample'),
    modelModifiers: { trim: true, number: true }
  },
  permissions: {
    label: t('cascadeSuperiorLinkDialog.permConfig'),
    slot: true,
    required: false,
    labelSlot: true,
    hiddenAllLabel: true,
    colOpt: { span: 24 },
    formItemOpt:{'label-width':'0px'},
    checkboxGroupOpt: { class: 'el-card cm-ui-pl15 cm-ui-pt10 cm-ui-pb10', style:  `margin-left: ${['zh-CN','zh-TW'].includes(locale.value) ? '20px':'25px'}` },
    type: FormType.CheckboxGroup,
    dictData: (Object.values(PermissionsState) as PermissionsState[]).map(value => ({
      label: t(`cascadeSuperiorLinkDialog.perm.${value}`),
      value
    }))
  }
}))

function getDefaultFormData (roleId = ''): Partial<CascadeAppliesData & AuthSubmitParams> {
  return {
    permissions: [],
    role_id: roleId,
    permission_type: authMode.loneAuth,
    status: ApplyState.Disconnect,
    access_code: '',
    server_host: '',
    server_port: undefined,
    child_server_host: window.location.protocol + '//' + window.location.hostname,
    child_server_port: ~~Number(window.location.port),
    children_team_id: '',
    data: [{ order_id: '', children_auth_count: 0 }]
  }
}

const innerVisible = computed({
  get: () => props.modelValue,
  set: (v: boolean) => emit('update:modelValue', v)
})
const labelWith = ref(['zh-CN','zh-TW'].includes(locale.value)  ? undefined : '120px')
const formRef = ref()
const form = ref({ ...getDefaultFormData() } as Partial<Apply> & Partial<CascadeAppliesData & AuthSubmitParams>)
const formState = ref(ActionTypes.Info)
const currentState = ref<string>(ApplyState.Disconnect)
const formOpt = ref<FormOpt>({
  confirmText: t('cascadeSuperiorLinkDialog.applyStates.disconnect.confirmText'),
  confirmBtnOpt: { disabled: false },
  // 中文不设置width，否则会显示不全
  'label-width': labelWith.value
})
const loading = ref(false)
const disabled = ref(false)
const dialogTitle = computed(() => t('cascadeSuperiorLinkDialog.title'))
const roleVisible = ref(false)
const roleMap = ref<Record<string, string>>({})
const role_id = ref('')
const roleFormItemDictData = ref<{ role_name: string; id: string }[]>([])

const roleFormItem = computed(() => ({
  label: t('cascadeSuperiorLinkDialog.role'),
  dictData: roleFormItemDictData.value,
  props: { label: 'role_name', value: 'id' },
  colOpt: { span: 22 },
  type: FormType.Select,
  selectOpt: { size: 'small', filterable: true }
}))

let rolesLoaded = false

async function getRoleList () {
  const res = await roleListApi({ limit: 9999, page: 1 }).catch(() => null)
  const list = res?.list ?? []
  const roleList = list.filter((item: { role_key: string }) => item.role_key !== Role_Key.RoleKeyAdmin)
  roleFormItemDictData.value = roleList
  role_id.value = roleList.find((item: { role_key: string }) => item.role_key === Role_Key.RoleKeyNormal)?.id ?? ''
  roleMap.value = roleList.reduce((p: Record<string, string>, c: { id: string; role_name: string }) => {
    p[c.id] = c.role_name
    return p
  }, {})
  rolesLoaded = true
}

async function loadApplyIntoForm () {
  const raw = (await getCascadeSuperiorApplyApi().catch(() => null)) as
    | { apply?: Partial<Apply> }
    | Partial<Apply>
    | null
  if (!raw) {
    form.value = { ...getDefaultFormData(role_id.value) }
    return
  }
  const apply =
    raw && typeof raw === 'object' && 'apply' in raw && raw.apply
      ? raw.apply
      : (raw as Partial<Apply>)
  if (!apply || typeof apply !== 'object') {
    form.value = { ...getDefaultFormData(role_id.value) }
    return
  }
  form.value = { ...getDefaultFormData(role_id.value), ...apply }
  form.value.permissions = Array.isArray(form.value.permissions) ? form.value.permissions : []
}

function syncFormOptFromState () {
  const st = (form.value.status || ApplyState.Disconnect) as ApplyState
  currentState.value = st
  const sk = applyStateLocaleKey[st]
  formOpt.value.cancelText = t(`cascadeSuperiorLinkDialog.applyStates.${sk}.cancelText`)
  formOpt.value.confirmText = t(`cascadeSuperiorLinkDialog.applyStates.${sk}.confirmText`)
  formOpt.value.confirmBtnOpt = {
    ...formOpt.value.confirmBtnOpt,
    disabled: st === ApplyState.Preview
  }
}

async function prepareOpen () {
  formState.value = ActionTypes.Info
  formOpt.value = { ...formOpt.value, 'label-position': 'left' }
  if (!rolesLoaded) {
    await getRoleList()
  }
  await loadApplyIntoForm()
  syncFormOptFromState()
}

watch(
  () => props.modelValue,
  v => {
    if (v) {
      void prepareOpen()
    }
  }
)

watch(locale, () => {
  if (props.modelValue) {
    syncFormOptFromState()
  }
})

function onDrawerClosed () {
  formRef.value?.ruleFormRef?.resetFields?.()
}

function handleReset () {
  const cancelType = ActionType[formState.value][currentState.value]?.cancelEventType as BtnActionType | undefined
  if (cancelType === BtnActionType.Revoke) {
    void handleRevoke()
  } else if (cancelType === BtnActionType.Disconnect) {
    void handleDisconnect()
  } else {
    innerVisible.value = false
  }
}

async function handleRevoke () {
  const result = await getCascadeRevokeApplyApi({ apply_id: form.value.id! }).catch(() => null)
  if (result) {
    emit('success')
    innerVisible.value = false
  }
}

async function handleDisconnect () {
  await ElMessageBox.confirm(
    t('cascadeBranchOverview.unbindSuperiorConfirm'),
    t('cascadeBranchOverview.tip'),
    {
      confirmButtonText: t('cascadeBranchOverview.confirm'),
      cancelButtonText: t('cascadeBranchOverview.cancel')
    }
  )
  const ok = await getCascadeUnbindApi({ cascade_relation_id: form.value.cascade_relation_id }).catch(() => false)
  ElMessage({
    type: ok ? 'success' : 'error',
    message: ok ? t('cascadeBranchOverview.unbindOk') : t('cascadeBranchOverview.unbindFail')
  })
  if (ok) {
    form.value = { ...getDefaultFormData(role_id.value) }
    formRef.value?.ruleFormRef?.resetFields?.()
    emit('success')
    innerVisible.value = false
  }
}

const handleSubmit: (
  valid: boolean,
  done: (ok: boolean, message?: string, normalClick?: boolean) => void
) => Promise<void> = async (valid, done) => {
  if (formState.value !== ActionTypes.Info) return
  if (!valid) return
  if ([ApplyState.Disconnect, ApplyState.Rejected].includes(form.value.status as ApplyState)) {
    if (form.value.id) {
      form.value.id = undefined as unknown as string
    }
  }
  const result = await getCascadeApplyApi(form.value as Apply).catch((error: { responseBody?: { ret?: string } }) => error)
  const code = result.responseBody?.ret
  const ok = result?.resp_common?.msg === 'ok'
  done(ok, errCodeToMsg[code as keyof typeof errCodeToMsg])
  innerVisible.value = !ok
  if (ok) {
    emit('success')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      modelValue: innerVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((innerVisible).value = $event)),
      title: dialogTitle.value,
      size: "60%",
      "destroy-on-close": "",
      "append-to-body": "",
      class: "cascade-superior-link-drawer",
      onClosed: onDrawerClosed
    }, {
      default: _withCtx(() => [
        _createVNode(CmForm, {
          "form-size": _unref(FormSize).Small,
          modelValue: form.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form).value = $event)),
          loading: loading.value,
          "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((loading).value = $event)),
          disabled: disabled.value,
          "onUpdate:disabled": _cache[5] || (_cache[5] = ($event: any) => ((disabled).value = $event)),
          "action-col-opt": { span: 24, style: 'display:flex;justify-content:flex-start' },
          "global-opt": { required: true },
          "form-opt": formOpt.value,
          style: {"padding":"16px","box-sizing":"border-box","display":"flex","flex-direction":"column","justify-content":"space-between","overflow":"hidden","height":"100%"},
          "row-opt": { style: 'overflow:auto;flex:none;', class: 'cm-ui-mb15' },
          ref_key: "formRef",
          ref: formRef,
          "form-columns": formColumns.value,
          onReset: handleReset,
          onSubmit: handleSubmit
        }, {
          permissions: _withCtx(({ formItem, prop }) => [
            _createVNode(FormItem, {
              prop: prop,
              modelValue: form.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form).value = $event)),
              "form-item": { ...formItem, hiddenAllLabel: false,formItemOpt: {'label-width': ['zh-CN','zh-TW'].includes(_unref(locale))  ? undefined : '120px'} }
            }, {
              "permissions-label": _withCtx(({label}) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(_unref(formLabelStyle))
                }, _toDisplayString(label), 5)
              ]),
              "permissions-password_free_login-checkbox": _withCtx(({ opt: { label } }) => [
                _createElementVNode("div", _hoisted_1, [
                  _createTextVNode(_toDisplayString(label) + " ", 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(!form.value.permissions.includes('password_free_login') && 'hide-role')
                  }, [
                    _createElementVNode("span", {
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                      style: {"color":"var(--cm-color-text-secondary)","cursor":"default"}
                    }, [
                      _createTextVNode(_toDisplayString(_unref(t)('cascadeSuperiorLinkDialog.superiorLoginLead')), 1),
                      _createElementVNode("span", {
                        style: _normalizeStyle(_unref(formLabelStyle))
                      }, _toDisplayString(roleMap.value[form.value.role_id] || '--'), 5),
                      _createTextVNode(_toDisplayString(_unref(t)('cascadeSuperiorLinkDialog.superiorLoginTrail')), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      style: {"outline":"none","border":"none","background-color":"transparent","color":"var(--el-color-primary)","cursor":"pointer"},
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (roleVisible.value = true), ["stop"])),
                      class: "cm-ui-ml5"
                    }, _toDisplayString(_unref(t)('cascadeSuperiorLinkDialog.changeRole')), 1)
                  ], 2)
                ])
              ]),
              _: 2
            }, 1032, ["prop", "modelValue", "form-item"])
          ]),
          _: 1
        }, 8, ["form-size", "modelValue", "loading", "disabled", "form-opt", "form-columns"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: roleVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((roleVisible).value = $event)),
      title: _unref(t)('cascadeSuperiorLinkDialog.selectSuperiorRoleTitle'),
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[8] || (_cache[8] = ($event: any) => {form.value.role_id = '2'; roleVisible.value = false})
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('cascadeSuperiorLinkDialog.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (roleVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('cascadeSuperiorLinkDialog.confirm')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(FormItem, {
              prop: "role_id",
              modelValue: form.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form).value = $event)),
              "form-item": roleFormItem.value
            }, null, 8, ["modelValue", "form-item"]),
            _createVNode(_component_el_tooltip, {
              placement: "bottom-start",
              effect: "light"
            }, {
              content: _withCtx(() => [
                _createVNode(_component_i18n_t, {
                  keypath: "cascadeSuperiorLinkDialog.roleTooltip",
                  tag: "div"
                }, {
                  settings: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      href: "/dashboard/admin-account-settings"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('cascadeSuperiorLinkDialog.settingsAdminAccount')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("i", _hoisted_4, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "views/dashboard/cascade-center/cascade-manage/assets/images/info",
                    size: 20,
                    monochrome: ""
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('cascadeSuperiorLinkDialog.afterSelectRole')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})